/** The needs-you count for every surface (lib/needs-you.ts), over the Inbox's own rows. */
import { useMemo } from 'react'
import { type NeedsYou, needsYou } from '../../lib/needs-you.js'
import { useInboxRows } from './useInboxRows.js'

export function useNeedsYou(): NeedsYou & { ready: boolean } {
  const built = useInboxRows()
  const ready = !!built.inbox.data
  return useMemo(() => ({ ...needsYou(built.rows), ready }), [built.rows, ready])
}
